// billing strings (en). Source of truth for the billing/plans/accounts surface.
const billing = {
	billing: {
		// Billing overview
		billingTitle: 'Billing',
		backToBilling: 'Back to Billing',
		backToBillingLower: 'back to billing',
		grabExclusiveDeals: 'Grab Our Exclusive %{type} Deals',
		lifetime: 'Lifetime',
		monthly: 'Monthly',
		insteadOfRegular: 'Instead of our regular',
		regularPriceStrike: '$9 per user/per month',
		pricingSuffix: 'pricing,',
		limitedTimeOffer: "we're offering pay-one lifetime deal for a limited time only.",
		annual: 'Annual',
		twentyPercentOff: '20% off',

		// Plan detail
		noPlanSelected: 'No plan selected',
		trialPeriod: 'Trial period',
		upcomingInvoice: 'Your upcoming invoice. You will be charged next after %{days}',
		days14: '14 days.',
		days30: '30 days.',
		days365: '365 days.',
		notSubscribed: 'Dear user, you are not subscribed to any plan. Kindly upgrade your plan.',
		planLineItem: '%{members} user x %{plan} Plan (at $%{price})',
		noWord: 'No',
		total: 'Total',
		upgradePlan: 'Upgrade Plan',
		managePayment: 'Manage payment',
		cancelSubscription: 'Cancel subscription',

		// Cancel subscription confirmation
		areYouSure: 'Are you sure?',
		cancelSubConfirm: 'Do you want to cancel your current subscription.',
		no: 'No',
		yes: 'Yes',

		// Plan limits
		limits: 'Limits',
		workspace: 'Workspace',
		teamMembers: 'Team Members',
		uniqueRecipients: 'Unique Recipients',
		cards: 'Cards',
		aiCredits: 'AI Credits',
		emailAccountsLabel: 'Email Accounts',
		of: 'of',
		used: 'used',
		ofUnlimitedUsed: 'of unlimited used',
		willBeRefreshed: 'will be refreshed on %{date}',
		lifetimeSubscription: 'You have lifetime plan subscription.',
		recipientsLimitTooltip: 'Recipients limit %{expiry}',
		cardsLimitTooltip: 'Cards limit %{expiry}',
		aiCreditsLimitTooltip: 'AI Credits limit %{expiry}',

		// Redeem codes
		cannotRedeemMore: 'Cannot redeem more than 8 codes',
		codeAlreadyAdded: 'Code already added',
		enterAppsumoCodeTitle: 'Enter AppSumo code',
		hitPlusIcon: "Hit '+' icon or press enter after typing your code",
		planUpdated: 'Plan updated!',
		redeem: 'Redeem',
		cancel: 'Cancel',

		// Common swal titles
		successTitle: 'Success',
		errorTitle: 'Error',
		oopsTitle: 'Oops',

		// Receipts / data table
		receipts: 'Receipts',
		paymentHistory: 'Your payment history for your subscription on CardClan',
		view: 'View',
		id: 'Id',
		plan: 'Plan',
		price: 'Price',
		totalCards: 'Total Cards',
		date: 'Date',

		// Change plan
		changePlan: 'Change Plan',

		// Email accounts list
		emailsTitle: 'Emails',
		connectEmailAccount: 'Connect Email Account',
		connectEmailAccountBtn: 'Connect email account',
		needHelpConnecting: 'Need help connecting email account?',
		successfullyDeleted: 'Successfully deleted',
		deleteAccountError: 'An error occured while deleting your account. Please, try again!',
		noEmailAccountLimit: 'Your plan does not allow creating email accounts. Please upgrade your plan to add email accounts.',
		noEmailAccounts: 'No email accounts connected yet.',
		getStartedConnecting: 'Get started by connecting a new Email account.',
		howToSetupSmtp: 'How to setup a smtp sender account?',

		// Email account modal
		editEmailAddress: 'Edit Email address',
		addEmailAddress: 'Add Email address',
		fromName: 'From name',
		userName: 'user name',
		smtpHost: 'SMTP Host',
		differentReplyTo: 'Set a different reply to address',
		fromEmail: 'From email',
		passwordLabel: 'password',
		smtpPort: 'SMTP Port',
		ssl: 'SSL',
		tls: 'TLS',
		replyTo: 'Reply to',
		updateSettings: 'Update Settings',
		saveSettings: 'Save Settings',
		accountUpdated: 'Your email account has been successfully updated',
		accountConnected: 'Your email account has been successfully connected',
		minChars: 'must be atleast 2 characters ',
		maxChars: 'must be atmost 25 characters ',
		invalidEmail: 'Invalid Email Format',
		emailRequired: 'Email Is Required',
		port25Blocked:
			'Email requests made through port 25 are blocked by the Host servers. It is advised to user some other port for this operation.',

		// Email account table
		name: 'Name',
		status: 'Status',
		action: 'Action',
		active: 'Active',
		edit: 'Edit',
		deleteWord: 'Delete',

		// White label
		whiteLabel: 'White Label',
		noCustomDomain: "You don't have your custom domain set up yet.",
		brandPresets: 'Brand Presets',
		brandingDescription: 'This is your branding that will appear in the whole platform',
		appTitle: 'App Title',
		appTitlePlaceholder: 'e.g. my-app',
		brandColorsTitle: 'Brand Colors',
		reset: 'Reset',
		save: 'Save',
		clickSaveToUpdate: 'Please click on Save button to update your changes.',
		invalidFile: 'Invalid file!',
		uploadLogo: 'Upload Logo',
		uploadImage: 'Upload Image',
		uploading: 'Uploading...',

		// Logo / color labels
		darkLogo: 'Dark Logo',
		lightLogo: 'Light Logo',
		favicon: 'Favicon',
		accentColor: 'Accent Color',
		backgroundColor: 'Background Color',
		sidebarColor: 'Sidebar Color',

		// Workspace domain
		workspaceDomain: 'Workspace Domain',
		loading: 'Loading...',
		domainsUsed: '%{used} of %{limit} workspace domains used',
		customDomainFor: 'Custom domain for "%{name}"',
		currentWorkspaceFallback: 'Current Workspace',
		assignDomainDesc: 'Assign a custom domain to this workspace for branded card links',
		domainName: 'Domain Name',
		saveDomain: 'Save Domain',
		checkDns: 'Check DNS',
		cnameInstructions:
			'Add the following CNAME record in your DNS settings. Your webmaster or server administrator can help set this up.',
		typeCol: 'Type',
		keyCol: 'Key',
		valueCol: 'Value',
		copy: 'copy',
		invalidDomain: 'Invalid domain. Do not include protocol (http/https)',
		domainRequired: 'Domain is required',
		domainCreated: 'Workspace domain created. Please configure your DNS and verify.',
		failedCreateDomain: 'Failed to create domain',
		domainVerified: 'Domain verified successfully! It is now active.',
		verificationFailed: 'Verification Failed',
		dnsVerificationFailed: 'DNS verification failed. Ensure CNAME points to ssl.cardclan.me',
		deletedTitle: 'Deleted',
		domainRemoved: 'Workspace domain has been removed.',
		failedDeleteDomain: 'Failed to delete domain',

		// Workspace domain add-on
		addonTitle: 'Workspace Custom Domains Add-on',
		addonDesc:
			'Assign unique custom domains to individual workspaces. Each workspace can have its own branded domain for card links.',
		addonHeading: 'Custom Domains for Workspaces',
		addonSubDesc: 'Each unit gives you 3 workspace custom domains. Adjust the quantity to get more.',
		perMonth: '/month',
		workspaceDomainsCount: '%{count} workspace domains',
		featureDomainsPerUnit: '3 workspace custom domains per unit',
		featureDnsVerification: 'DNS verification with CNAME',
		featureAdjustableQty: 'Adjustable quantity at checkout',
		purchaseAddon: 'Purchase Add-on',

		// Video card settings
		videoCardSettingsPageTitle: 'Video Card Settings | CardClan',
		videoCards: 'Video Cards',
		videoCardsDesc: 'Control whether video cards are available for members of this workspace.',
		enableVideoCards: 'Enable Video Cards',
		enableVideoCardsDesc:
			'When disabled, workspace members cannot create video cards or access the video cards section.',
		saved: 'Saved!',
		failedSave: 'Failed to save',
		enabled: 'Enabled',
		disabled: 'Disabled',

		// Integration key
		generateIntegrationKey: 'Generate Integration Key',
		integrationKeyDesc: 'Use this key to connect with external automation platforms like Pabbly Connect',
		integrationKeyCreated: 'Integration key is successfully created.',
		usageInstructions: 'Usage Instructions:',
		usageStep1: 'Copy this key to your clipboard',
		usageStep2: 'In Pabbly Connect, create a new connection',
		usageStep3: 'Paste this key as the Bearer token or API key',
		integrationKeyExists: 'Integration key already exists',
		integrationKeyExistsDesc:
			'You already have an integration key for a different platform. You can only have one integration key per account.',
		integrationKeyGenerated: 'Integration key generated successfully!',
		failedGenerateIntegrationKey: 'Failed to generate integration key',
		integrationKeyCopied: 'Integration key copied successfully',

		// Zapier key
		generateZapierKey: 'Generate Zapier Key',
		generateZapierKeyBtn: 'Generate Zapier key',
		zapierKeyDesc: 'Use this key in your zapier app for authentication',
		zapierKeyCreated: 'Zapier key is successfully created.',
		keyCopied: '%{title} key copied successfully',

		// Preview card
		previewCard: 'Preview Card',
		previewCardDesc: 'Customize how your card looks in an email and when someone opens it.',
		chooseCardBackground: 'Choose Card Background',
		background: 'Background',
		toggleConfetti: 'Toggle Confetti',
		addCompanyLogo: 'Add Company Logo',
		logoDimensionNote: '* for optimal view for company logo dimension should be 400 x 100',
		viewCardButtonDesign: '“View Card” Button Design of Email',
		preview: 'Preview',
		buttonText: 'Button Text',
		buttonRounded: 'Button Rounded',
		buttonColor: 'Button Color',
		saveChanges: 'Save changes',
		viewChanges: 'View Changes',
		changesSaved: 'Changes saved successfully.',
		previewGreeting: 'Hey name, %{name} created a digital card',
		previewFooter: 'Your inbox just got a special delivery. View your card online.',

		// Settings navigation
		navYourProfile: 'Your Profile',
		navBilling: 'Billing',
		navManageWorkspaces: 'Manage Workspaces',
		navBasicSettings: 'Basic Settings',
		navTeamMembers: 'Team Members',
		navEmailAccounts: 'Email Accounts',
		navCustomDomainSettings: 'Custom Domain Settings',
		navDashboard: 'Dashboard',
		navMyCards: 'My Cards',
		navSettings: 'Settings',
		accountSettings: 'Account Settings',
		whiteLabelSettingsSection: 'White Label Settings',
	},
};
export default billing;
